/* Stable viewport anchors for Tidio v4 + Judge.me. No app data or handlers changed. */
(() => {
  'use strict';
  if (!document.documentElement.hasAttribute('data-kp-mobile-widgets')) return;
  const media = matchMedia('(max-width: 767px)');
  const shadowCSS = `
    @media(max-width:767px) {
      .widgetLabel { display:none!important; }
      #button.chat-closed {
        position:fixed!important;top:auto!important;left:auto!important;
        inset-block-start:auto!important;inset-inline-start:auto!important;
        margin:0!important;right:16px!important;
        bottom:calc(16px + env(safe-area-inset-bottom,0px))!important;
        transform:none!important;
        width:48px!important;height:48px!important;
        transition:box-shadow .2s!important;
        align-self:auto!important;justify-self:auto!important;z-index:10!important;
      }
      #button.chat-closed #button-body { width:48px!important;height:48px!important; }
      #button.chat-closed[data-kp-hidden] { visibility:hidden!important;pointer-events:none!important; }
    }`;
  let shadow = null;
  let shadowObserver = null;
  let frame = 0;

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function setHidden(el, hide) {
    if (el && el.hasAttribute('data-kp-hidden') !== hide) {
      el.toggleAttribute('data-kp-hidden', hide);
    }
  }
  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    if (el.checkVisibility && !el.checkVisibility({checkOpacity:true, checkVisibilityCSS:true})) return false;
    const s = getComputedStyle(el);
    const r = el.getBoundingClientRect();
    return s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) !== 0 &&
      r.width > 0 && r.height > 0;
  }
  function attachShadow() {
    const next = document.getElementById('tidio-chat')?.shadowRoot;
    if (!next) return;
    if (shadow !== next) {
      shadowObserver?.disconnect();
      shadow = next;
      shadowObserver = new MutationObserver(schedule);
      shadowObserver.observe(shadow, {subtree:true, childList:true, attributes:true,
        attributeFilter:['class', 'style', 'aria-hidden']});
    }
    if (!shadow.querySelector('#kp-mobile-widget-style')) {
      const style = document.createElement('style');
      style.id = 'kp-mobile-widget-style';
      style.textContent = shadowCSS;
      shadow.appendChild(style);
    }
  }
  function update() {
    frame = 0;
    attachShadow();
    const reviews = document.querySelector('.jdgm-revs-tab-btn');
    const chat = shadow?.querySelector('#button');
    if (!media.matches) {
      setHidden(reviews, false);
      setHidden(chat, false);
      return;
    }
    const chatOpen = !!chat?.classList.contains('chat-open');
    const reviewsOpen = [...document.querySelectorAll('.jdgm-modal__content[role="dialog"]')].some(visible);
    const lightboxOpen = [...document.querySelectorAll('.pg-lightbox')].some(visible);
    const keyboardOpen = !!window.visualViewport && innerHeight - visualViewport.height > 150;
    // CSS pins both launchers to the viewport. Never track scrolling product content.
    // Keep native dialogs unobstructed without moving a launcher to another position.
    setHidden(reviews, chatOpen || reviewsOpen || lightboxOpen || keyboardOpen);
    if (chat && !chatOpen) {
      setHidden(chat, reviewsOpen || lightboxOpen || keyboardOpen);
    } else {
      setHidden(chat, false);
    }
  }
  new MutationObserver(schedule).observe(document.body, {
    subtree:true, childList:true, attributes:true,
    attributeFilter:['class', 'style', 'aria-hidden', 'open']
  });
  addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('resize', schedule, {passive:true});
  media.addEventListener('change', schedule);
  // Shadow attachment alone does not trigger a document observer.
  let attempts = 0;
  const timer = setInterval(() => {
    schedule();
    if (shadow || ++attempts >= 120) clearInterval(timer);
  }, 500);
  schedule();
})();
